import { render, staticRenderFns } from "./UiLoader.vue?vue&type=template&id=1c175ba6&scoped=true&"
var script = {}
import style0 from "./UiLoader.vue?vue&type=style&index=0&id=1c175ba6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c175ba6",
  null
  
)

export default component.exports